import { Box, TextField, Typography } from "@mui/material";
import { SalesAidsStyles } from "./SalesAidsStyles";

const RequestQuoteArtifact = ({ artifacts, setArtifacts, edit }) => {
  const handleTextChange = (field, value) => {
    setArtifacts((prev) => ({
      ...prev,
      request_quote_artifact: {
        ...prev.request_quote_artifact,
        [field]: value,
        isEdit: true,
      },
    }));
  };
  const handleOptionChange = (optionIndex, value, field) => {
    setArtifacts((prev) => ({
      ...prev,
      request_quote_artifact: {
        ...prev.request_quote_artifact,
        [field]: (prev.request_quote_artifact[field]?.length
          ? prev.request_quote_artifact[field]
          : Array(2).fill("")
        ).map((option, j) => (j === optionIndex ? value : option)),
        isEdit: true,
      },
    }));
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        p: "6px",
        borderRadius: 2,
        bgcolor: artifacts?.isEdit ? "#FFF7F7" : null,
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          width: "100%",
          height: "100%",
        }}
      >
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography fontSize={15} fontWeight="bold" color="gray">
            English
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label={"Message to be displayed"}
            onChange={(e) => handleTextChange("text", e.target.value)}
            value={artifacts?.text}
            multiline
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
              width: "100%",
              height: "100%",
            }}
          >
            {(artifacts?.quote_options?.length
              ? artifacts?.quote_options
              : Array(2).fill("")
            ).map((option, optionIndex) => (
              <TextField
                fullWidth
                variant="outlined"
                sx={SalesAidsStyles.surveyButton}
                onChange={(e) =>
                  handleOptionChange(
                    optionIndex,
                    e.target.value,
                    "quote_options"
                  )
                }
                value={option || ""}
                multiline
              />
            ))}
          </Box>
        </Box>

        {/* Spanish Column */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography fontSize={15} fontWeight="bold" color="gray">
            Spanish
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label={"Mensaje a mostrar"}
            onChange={(e) => handleTextChange("es_text", e.target.value)}
            value={artifacts?.es_text}
            multiline
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
              width: "100%",
              height: "100%",
            }}
          >
            {(artifacts?.es_quote_options?.length
              ? artifacts?.es_quote_options
              : Array(2).fill("")
            ).map((option, optionIndex) => (
              <TextField
                fullWidth
                variant="outlined"
                sx={SalesAidsStyles.surveyButton}
                onChange={(e) =>
                  handleOptionChange(
                    optionIndex,
                    e.target.value,
                    "es_quote_options"
                  )
                }
                value={option || ""}
                multiline
              />
            ))}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          width: "100%",
          height: "100%",
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          label={"Message to be displayed"}
          onChange={(e) => handleTextChange("quote_question", e.target.value)}
          value={artifacts?.quote_question}
          multiline
        />

        <TextField
          fullWidth
          variant="outlined"
          label={"Mensaje a mostrar"}
          onChange={(e) =>
            handleTextChange("es_quote_question", e.target.value)
          }
          value={artifacts?.es_quote_question}
          multiline
        />
      </Box>
    </Box>
  );
};

export default RequestQuoteArtifact;
